<template>
    <dialogComponent name="ieAlert">
        <template v-slot="dialog">
            <div class="fakemodal warm-modal">
                <div class="content">
                    <div class="modal-header">
                        <div v-html="dialog.options.title"></div>
                    </div>
                    <div class="modal-content">
                        <div class="modal-body msg-alert" style="display: inline-block;">为提供最佳的游戏体验，请使用平台建议的浏览器Google Chrome、Firefox、搜狗！</div>
                    </div>
                </div>
                <div class="mask"></div>
            </div>
        </template>
    </dialogComponent>
</template>

<script>
export default {
    name: "IEAlert",
    methods: {
        showDialog() {
            let _ieAlertDialog = this.$dialog.get('ieAlert');
            _ieAlertDialog.show();
        },
    },
}
</script>